<div class="container">
  <div class="loading-overlay" *ngIf="loading">
    <mat-progress-spinner mode="indeterminate" diameter="40" strokeWidth="3"></mat-progress-spinner>
  </div>

  <form class="card-form" [formGroup]="dpForm" (ngSubmit)="submitForm()" autocomplete="off" novalidate>
    <div class="blue-top">
      <img class="blue-top-logo" src="app/assets/icea-logo.png" alt="ICEA LION" />
      <span class="blue-top-title">Home Insurance Details</span>
    </div>

    <div class="card-section top-section">
      <h2>Enter building details</h2>
      <p class="section-hint">Please provide the details of the building to be insured</p>

      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">Type of building</mat-label>
        <mat-select formControlName="buildingType" panelClass="form-select-popup" (blur)="logErrors()">
          <mat-option class="form-option" [value]="opt" *ngFor="let opt of buildingTypeOptions">
            {{opt}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="formErrors['buildingType']">{{formErrors['buildingType']}}</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">Number of storeys</mat-label>
        <input matInput formControlName="numberOfStoreys" inputmode="numeric" maxlength="3" (blur)="logErrors()">
        <mat-error *ngIf="formErrors['numberOfStoreys']">{{formErrors['numberOfStoreys']}}</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">LR number</mat-label>
        <input matInput formControlName="lrNumber" spellcheck="false" (blur)="logErrors()">
        <mat-error *ngIf="formErrors['lrNumber']">{{formErrors['lrNumber']}}</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">Street address</mat-label>
        <input matInput formControlName="streetAddress" (blur)="logErrors()">
        <mat-error *ngIf="formErrors['streetAddress']">{{formErrors['streetAddress']}}</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">GPS Coordinates (optional)</mat-label>
        <input matInput formControlName="gpsCoordinates" spellcheck="false">
        <mat-hint>This is optional</mat-hint>
      </mat-form-field>

      <div class="row-div margin-top-50">
        <button mat-stroked-button type="button" (click)="confirmCancel()">
          <span class="button-text">Cancel</span>
        </button>
        <button mat-button type="submit" [disabled]="!dpForm.valid">
          <span class="button-text">Save and Continue</span>
        </button>
      </div>
    </div>
  </form>
</div>
